import { CIMSTags } from 'components/CIMSTags'
import { DesignSubmittal } from '../../../../../../DesignSubmittalLogContext/types'

export const Actions: React.VFC<DesignSubmittal> = ({ actions }) => {
  return (
    <CIMSTags
      direction={{ tags: 'vertical' }}
      tags={actions.map(({ name, id, description }) => ({
        text: name,
        key: id,
        tooltip: description,
      }))}
    />
  )
}
